import { usePlatformStore } from '@/store-pinia/platform'
import { PlatformSource } from '@/view-models/platform'
import { getIsFunBookV2DomainCustomization } from '@/utils/funbookV2'

export default defineNuxtRouteMiddleware((to, from) => {
  const config = useRuntimeConfig()
  const nuxtApp = useNuxtApp()
  const $pinia = nuxtApp.$pinia
  const store = nuxtApp.$store
  const route = to
  const req = useRequestURL()

  const platformStore = usePlatformStore($pinia)
  // excludes FunBook1.0 path('funbook-branch_id-real_contact' and 'funbook-branch_id-booking')
  const isFunBookV2Path =
    route.name?.includes('funbook-branch_id') &&
    !route.name?.includes('real_contact') &&
    !(route.name?.includes('booking') && !route.name?.includes('booking-product_id'))
  const isFunBookV1Path = !isFunBookV2Path && route.name?.includes('funbook')

  const { host, origin } = req
  const isLocalhost = host.startsWith('localhost')
  const isFunBookV2 = isFunBookV2Path || (!isLocalhost && getIsFunBookV2DomainCustomization(host))
  const isFunNowDomain = origin === config.public.BASE_URL

  platformStore.name = isFunBookV2 ? PlatformSource.FunBook : PlatformSource.FunNow
  platformStore.isFunBookV2Path = isFunBookV2Path
  platformStore.isFunBookV1Path = isFunBookV1Path
  platformStore.isFunBookV2DomainCustomization = getIsFunBookV2DomainCustomization(host)
  platformStore.isFunNowDomain = isLocalhost || isFunNowDomain

  if (isFunBookV2 && store.state.isBookingEngine && route.query.subdomain) {
    return navigateTo(nuxtApp.$localePath(route.path))
  }
})
